'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _CouponStore = require('../../stores/CouponStore');

var _CouponStore2 = _interopRequireDefault(_CouponStore);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _CustomChargePriceView = require('./custom-charge/CustomChargePriceView');

var _CustomChargePriceView2 = _interopRequireDefault(_CustomChargePriceView);

var _CouponHolder = require('../coupon/CouponHolder');

var _CouponHolder2 = _interopRequireDefault(_CouponHolder);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CartPriceStructure = (0, _createReactClass2.default)({
    displayName: 'CartPriceStructure',


    mixins: [_reflux2.default.listenTo(_CouponStore2.default, 'onCouponChange')],

    getInitialState: function getInitialState() {
        return {
            isGuest: false,
            isCouponApplied: false
        };
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            this.setState({
                orderType: _CartStore2.default.getOrderType()
            });
        }
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
        var isCouponApplied = false;
        if (_CartStore2.default.getCouponCode()) {
            isCouponApplied = true;
        }

        this.setState({
            couponCode: _CartStore2.default.getCouponCode(),
            isCouponApplied: isCouponApplied
        });
    },
    onCouponChange: function onCouponChange(event, couponObject) {
        if (couponObject.couponCode) {
            this.setState({
                isCouponApplied: true,
                couponCode: couponObject.couponCode
            });
        } else {
            this.setState({
                isCouponApplied: false,
                couponCode: null
            });
        }
    },
    getCouponStructure: function getCouponStructure() {
        var component = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: 'disc-highlight' },
                'Discount ',
                _react2.default.createElement(
                    'b',
                    {
                        className: 'pull-right' },
                    ' -$',
                    _CartStore2.default.getDiscountAmountRounded()
                )
            ),
            _react2.default.createElement(
                'p',
                null,
                'Discounted sub total: ',
                _react2.default.createElement(
                    'b',
                    {
                        className: 'pull-right' },
                    ' $',
                    _CartStore2.default.getCartSubTotalWithDiscountRounded()
                )
            )
        );
        if (this.state.isCouponApplied || _CartStore2.default.getCouponCode()) {
            return component;
        } else {
            return null;
        }
    },
    getDeliveryFeeStructure: function getDeliveryFeeStructure() {
        var component = null;
        var orderType = _CartStore2.default.getOrderType();
        if (orderType == Constants.DELIVERY) {
            component = _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    'delivery fee: ',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right' },
                        '$',
                        _CartStore2.default.getDeliveryFeeRounded(2)
                    )
                )
            );
        }
        return component;
    },
    getServiceFeeStructure: function getServiceFeeStructure() {
        // Retrieve service fee description from CartStore
        var serviceFeeDesc = _CartStore2.default.getServiceFeeDesc();
        // Check if service fee is available from CartStore
        var isServiceFeeAvailable = _CartStore2.default.isServiceFeeAvailable();
        var component = null;

        // If service fee is available (not null or undefined)
        if (isServiceFeeAvailable != null) {
            var serviceFeeObj = isServiceFeeAvailable;
            // Generate JSX component for service fee description if available
            var serviceFeeDescComponent = serviceFeeDesc && _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    'a',
                    { 'data-tip': serviceFeeDesc, className: 'color-styl tooltip-button cursor-pointer' },
                    _react2.default.createElement('i', { className: 'fa fa-info-circle' })
                ),
                _react2.default.createElement(_reactTooltip2.default, { place: 'right', wrapper: 'span' })
            );

            // Calculate subtotal of cart with discount
            var subTotal = _.round(_CartStore2.default.getCartSubTotalWithDiscountRounded(), 2);
            // Get minimum amount required for service fee (default to 0 if not provided)
            var minAmount = serviceFeeObj.minAmount || 0;

            // If cart subtotal is greater than or equal to minimum amount required for service fee
            if (subTotal >= minAmount) {
                component = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        { className: 'text-secondary-light' },
                        'Service Fee: ',
                        serviceFeeDescComponent,
                        _react2.default.createElement(
                            'b',
                            { className: 'pull-right' },
                            '$',
                            _CartStore2.default.getServiceFeeRounded()
                        )
                    )
                );
            }
        }

        // Return the constructed component
        return component;
    },
    getTipStructure: function getTipStructure() {

        var tipAmount = _CartStore2.default.getTip();
        var component = _react2.default.createElement(
            'p',
            { className: 'text-secondary-light' },
            'tip: ',
            _react2.default.createElement(
                'b',
                { className: 'pull-right' },
                '$',
                _.round(tipAmount, 2).toFixed(2)
            )
        )
        // <p>tip: <b className="pull-right">${CartStore.getTip()}</b></p>
        ;
        return component;
    },
    changeCouponStatus: function changeCouponStatus(isCouponSuccess) {
        this.setState({
            isCouponApplied: isCouponSuccess
        });
    },
    getCouponComponent: function getCouponComponent() {
        var _React$createElement;

        var component = _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_CouponHolder2.default, (_React$createElement = {
                informParent: this.changeCouponStatus,
                isCouponApplied: this.state.isCouponApplied,
                bizId: _CartStore2.default.getBusinessDetailId(),
                locId: _CartStore2.default.getLocationDetailId(),
                subTotal: _CartStore2.default.getCartTotalWithoutTaxRounded(),
                couponCode: this.state.couponCode,
                isLoggedInExistingUser: this.props.isLoggedInExistingUser
            }, _defineProperty(_React$createElement, 'locId', this.props.locId), _defineProperty(_React$createElement, 'history', this.props.history), _React$createElement))
        );

        return component;
    },
    render: function render() {

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            this.getCouponComponent(),
            _react2.default.createElement('span', { className: 'col-xs-12 mt-20 cart_border' }),
            _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                    'div',
                    { className: 'container no-gutter', style: { maxWidth: '100%' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'car_border', id: 'price-table' },
                        _react2.default.createElement(
                            'div',
                            { className: 'offset-lg-4 col-lg-8 mb-3 px-0 pr-0' },
                            _react2.default.createElement(
                                'div',
                                { className: 'cart_right cart_right-nopadding' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'text-secondary-light' },
                                    'sub total: ',
                                    _react2.default.createElement(
                                        'b',
                                        {
                                            className: 'pull-right' },
                                        ' $',
                                        _CartStore2.default.getCartTotalWithoutTaxRounded()
                                    )
                                ),
                                this.getCouponStructure(),
                                this.getDeliveryFeeStructure(),
                                _react2.default.createElement(
                                    'p',
                                    { className: 'text-secondary-light' },
                                    'Taxes: ',
                                    _react2.default.createElement(
                                        'b',
                                        {
                                            className: 'pull-right' },
                                        ' $',
                                        _CartStore2.default.getTaxedPriceRounded()
                                    )
                                ),
                                this.getServiceFeeStructure(),
                                this.getTipStructure(),
                                _react2.default.createElement(_CustomChargePriceView2.default, {
                                    orderType: this.state.orderType
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cart_total' },
                                _react2.default.createElement(
                                    'h4',
                                    { className: 'color-styl' },
                                    'Total',
                                    _react2.default.createElement(
                                        'span',
                                        {
                                            className: 'pull-right' },
                                        ' $',
                                        _CartStore2.default.getCartTotalRounded()
                                    )
                                )
                            )
                        )
                    )
                )
            )
        );
    }
});

exports.default = CartPriceStructure;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/CartPriceStructure.jsx
// module id = 564
// module chunks = 0